import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-periodieke-uitkeringen',
  templateUrl: './periodieke-uitkeringen.component.html',
  styleUrls: ['./periodieke-uitkeringen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class PeriodiekeUitkeringenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;

    private isSaving = false;
    public clientId!: string;
    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public toonRevisierente = false;

    private focusedElementId: string | null = null;

    public periodiekeUitkeringen = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.periodiekeUitkeringen = this.fb.group({
            ontvangenPU: this.fb.array<OmschrijvingEnBedrag>([]),
            kostenPU: this.fb.array<OmschrijvingEnBedrag>([]),
            revisierente: null as unknown as number,
            omschrijving: 'Berekende revisierente',
        })
    }

    get ontvangenPU(): FormArray {
        return this.periodiekeUitkeringen.get("ontvangenPU") as FormArray;
    }

    get kostenPU(): FormArray {
        return this.periodiekeUitkeringen.get("kostenPU") as FormArray;
    }

    addRijOntvangenPU(): void {
        this.ontvangenPU.push(this.createPUOntvangenFormGroup()
        )
    }

    addRijKostenPU(): void {
        this.kostenPU.push(this.createPUKostenFormGroup()
        )
    }

    verwijderRijOntvangenPU(index: number): void {
        this.ontvangenPU.removeAt(index);
        this.periodiekeUitkeringen.updateValueAndValidity()
        this.periodiekeUitkeringen.markAsDirty()
        this.saveForm();
    }

    verwijderRijKostenPU(index: number): void {
        this.kostenPU.removeAt(index);
        this.periodiekeUitkeringen.updateValueAndValidity()
        this.periodiekeUitkeringen.markAsDirty()
        this.saveForm();
    }

    createPUOntvangenFormGroup(pu?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: pu ? pu.omschrijving : undefined,
            bedrag: pu ? pu.bedrag : undefined
        } as OmschrijvingEnBedrag))
    }

    createPUKostenFormGroup(pueKosten?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: pueKosten ? pueKosten.omschrijving : undefined,
            bedrag: pueKosten ? pueKosten.bedrag : undefined
        } as OmschrijvingEnBedrag))
    }



    public ngOnInit(): void {
       this.incomeTaxEntitySubscription= this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.periodiekeUitkeringen.reset()
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.periodiekeUitkeringen.dirty;
  }

    private updateForm(): void {
        console.log('updateForm aangeroepen, toonRevisierente was:', this.toonRevisierente);

        let puOntvangenLijst = this.partnerBoolean
            ? this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.inkomstenPeriodiekeUitkeringen || []
            : this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.inkomstenPeriodiekeUitkeringen || [];

        const formArray = this.periodiekeUitkeringen.get('ontvangenPU') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > puOntvangenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }
        for (let i = 0; i < puOntvangenLijst.length; i++) {
            if (i < formArray.length) {
                (formArray.at(i) as FormGroup).patchValue(puOntvangenLijst[i]);
            } else {
                formArray.push(this.createPUOntvangenFormGroup(puOntvangenLijst[i]));
            }
        }

        let puKostenLijst = this.partnerBoolean
            ? this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen || []
            : this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen || [];

        const formArrayKosten = this.periodiekeUitkeringen.get('kostenPU') as FormArray;
        while (formArrayKosten.length > puKostenLijst.length) {
            formArrayKosten.removeAt(formArrayKosten.length - 1);
        }
        for (let i = 0; i < puKostenLijst.length; i++) {
            if (i < formArrayKosten.length) {
                (formArrayKosten.at(i) as FormGroup).patchValue(puKostenLijst[i]);
            } else {
                formArrayKosten.push(this.createPUKostenFormGroup(puKostenLijst[i]));
            }
        }

        const revisierente = this.partnerBoolean
            ? this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.revisierente
            : this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.revisierente;

        this.periodiekeUitkeringen.patchValue({
            revisierente: revisierente ?? null,
            omschrijving: 'Berekende revisierente'
        });
        // Toon veld direct als er al een waarde is
        if (revisierente !== null && revisierente !== undefined) {
            this.toonRevisierente = true;
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbarePeriodiekeUitkeringenEnVerstrekkingen: {
                        ...this.aangifte.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen,
                        inkomstenPeriodiekeUitkeringen: this.periodiekeUitkeringen.value.ontvangenPU,
                        aftrekbareKostenPeriodiekeUitkeringen: this.periodiekeUitkeringen.value.kostenPU,
                        revisierente: this.periodiekeUitkeringen.value.revisierente
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        belastbarePeriodiekeUitkeringenEnVerstrekkingen: {
                            ...this.aangifte.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen,
                            inkomstenPeriodiekeUitkeringen: this.periodiekeUitkeringen.value.ontvangenPU,
                            aftrekbareKostenPeriodiekeUitkeringen: this.periodiekeUitkeringen.value.kostenPU,
                            revisierente: this.periodiekeUitkeringen.value.revisierente
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.periodiekeUitkeringen.markAsDirty()
    }

    public addRevisierente(): void {
        this.toonRevisierente = true;
    }

    public verwijderRevisierente(): void {
        this.periodiekeUitkeringen.patchValue({ revisierente: null });
        this.toonRevisierente = false;
        this.saveForm();
    }
}
